import React, { Component } from "react";
import AudioWorkCutRender from "./children/AudioWorkCutRender";
import Utils from "@/utils";
import moment from "moment";
import sentGAEvent from "@/ga";
import "@/assets/audioCutSpeedVolume.less";

class AudioWorkCutFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleFormatChange = value => {
    this.setState({
      format: value,
    });
  };

  handleTimeStepChange = (value, key) => {
    this.props.handleTimeChangeType("ambos");
    if (key === "end" && value > 0) {
      if (Utils.getSeconds(this.props.audioCutSpeedVolumeObj.end) >= Utils.getSeconds(this.props.audioCutSpeedVolumeObj.duration)) {
        return false;
      }
    } else if (key === "start" && value < 0) {
      if (Utils.getSeconds(this.props.audioCutSpeedVolumeObj.start) <= 0) {
        return false;
      }
    }
    const audioCutSpeedVolumeObj = { ...this.props.audioCutSpeedVolumeObj };
    audioCutSpeedVolumeObj[key] = moment("00:00:00", "mm:ss:SS")
      .add(Utils.getSeconds(audioCutSpeedVolumeObj[key]) + value, "seconds")
      .format("mm:ss:SS")
      .replace(/:([^:]*)$/, ".$1");
    if (key === "start" && Utils.getSeconds(audioCutSpeedVolumeObj[key]) >= audioCutSpeedVolumeObj.wavesurfer.getCurrentTime()) {
      audioCutSpeedVolumeObj.wavesurfer.setCurrentTime(Utils.getSeconds(audioCutSpeedVolumeObj.start));
      this.props.handleIsAudioCurrentTimeChange(!this.props.isAudioCurrentTimeChange);
    } else if (key === "end" && Utils.getSeconds(audioCutSpeedVolumeObj[key]) <= audioCutSpeedVolumeObj.wavesurfer.getCurrentTime()) {
      audioCutSpeedVolumeObj.wavesurfer.setCurrentTime(Utils.getSeconds(audioCutSpeedVolumeObj.end));
      this.props.handleIsAudioCurrentTimeChange(!this.props.isAudioCurrentTimeChange);
    }
    this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
  };

  handleFade = type => {
    const audioCutSpeedVolumeObj = { ...this.props.audioCutSpeedVolumeObj };
    if (type === "in") {
      sentGAEvent({
        category: "audio_cut_action",
        action: "audio_cut_fade_click",
        label: "fade_in_click",
      });
      audioCutSpeedVolumeObj.fadeIn = audioCutSpeedVolumeObj.fadeIn ? false : true;
      this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
    } else {
      sentGAEvent({
        category: "audio_cut_action",
        action: "audio_cut_fade_click",
        label: "fade_out_click",
      });
      audioCutSpeedVolumeObj.fadeOut = audioCutSpeedVolumeObj.fadeOut ? false : true;
      this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
    }
  };

  handleCutOrTrim = e => {
    this.props.handlePauseAudio();
    const audioCutSpeedVolumeObj = { ...this.props.audioCutSpeedVolumeObj };
    audioCutSpeedVolumeObj.cutOrTrim = e.target.value;
    if (e.target.value === "trim") {
      sentGAEvent({
        category: "audio_cut_action",
        action: "audio_cut_select_click",
        label: "delete_selected",
      });
      audioCutSpeedVolumeObj.wavesurfer.seekTo(0);
    } else {
      sentGAEvent({
        category: "audio_cut_action",
        action: "audio_cut_select_click",
        label: "extract_selected",
      });
      audioCutSpeedVolumeObj.wavesurfer.seekTo(Utils.getSeconds(audioCutSpeedVolumeObj.start) / Utils.getSeconds(audioCutSpeedVolumeObj.duration));
    }
    this.props.handleIsAudioCurrentTimeChange(!this.props.isAudioCurrentTimeChange);
    this.props.onAudioCutSpeedVolumeObjChange(audioCutSpeedVolumeObj);
  };

  componentDidMount() {
    sentGAEvent({
      category: "audio_cut_page",
      action: "audio_cut_functionpage_display",
    });
  }

  render() {
    return (
      <AudioWorkCutRender
        audioCutSpeedVolumeObj={this.props.audioCutSpeedVolumeObj}
        handleTimeStepChange={this.handleTimeStepChange}
        handleCutOrTrim={this.handleCutOrTrim}
        handleFade={this.handleFade}
        tooglePlay={() => {
          this.props.tooglePlay();
        }}
        playing={this.props.playing}
      />
    );
  }
}

export default AudioWorkCutFunction;
